import { motion } from "framer-motion";
import { LineReveal, Eyebrow } from "./motion";

export const PageHero = ({ eyebrow, lines, intro, children, testId = "page-hero" }) => (
  <section data-testid={testId} className="relative overflow-hidden bg-mist pb-16 pt-36 md:pb-24 md:pt-44">
    <div className="pointer-events-none absolute inset-0 grid-lines opacity-70" />
    <div className="pointer-events-none absolute -right-24 top-10 h-[420px] w-[420px] rounded-full border border-gold/40" />
    <div className="pointer-events-none absolute -right-8 top-28 h-[260px] w-[260px] rounded-full border border-navy/10" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
        <Eyebrow>{eyebrow}</Eyebrow>
      </motion.div>
      <h1 className="mt-6 max-w-5xl text-4xl font-bold leading-[1.05] tracking-tight text-navy sm:text-5xl lg:text-6xl">
        <LineReveal lines={lines} delay={0.1} />
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-slate2 md:text-lg"
        >
          {intro}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
